import React, { useEffect, useState } from 'react';
import { API_BASE } from '../utils';

export default function SourceImage({ questionId }: { questionId: number }) {
  const [zoom, setZoom] = useState(100);
  const [failed, setFailed] = useState(false);
  const [retry, setRetry] = useState(0);
  useEffect(() => { setZoom(100); setFailed(false); }, [questionId]);
  return <section className="source-image" aria-label="原图对照">
    <div className="source-image-toolbar"><strong>原图对照</strong>
      <button type="button" className="text-button" aria-label="缩小原图" disabled={zoom <= 50} onClick={() => setZoom(v => Math.max(50, v - 25))}>−</button>
      <span aria-live="polite">{zoom}%</span>
      <button type="button" className="text-button" aria-label="放大原图" disabled={zoom >= 400} onClick={() => setZoom(v => Math.min(400, v + 25))}>＋</button>
      <button type="button" className="text-button" onClick={() => setZoom(100)}>恢复比例</button>
    </div>
    {failed ? <p role="alert">原图加载失败 <button type="button" className="text-button" onClick={() => { setFailed(false); setRetry(v => v + 1); }}>重试原图</button></p>
      : <div className="source-image-viewport"><img src={`${API_BASE}/questions/${questionId}/image?retry=${retry}`} alt="题目原图" style={{ width: `${zoom}%`, maxWidth: 'none' }} onError={() => setFailed(true)} /></div>}
  </section>;
}
